//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const EVENT_DRIVEN_PROCESS_TRACKING_API_BASE_URL = new InjectionToken<string>('EVENT_DRIVEN_PROCESS_TRACKING_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class EventDrivenProcessTrackingApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(EVENT_DRIVEN_PROCESS_TRACKING_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "/";
    }

    /**
     * @param eventId (optional) 
     * @param correlationId (optional) 
     * @param messageId (optional) 
     * @param companyId (optional) 
     * @param integrationEventId (optional) 
     * @param entityId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param top (optional) 
     * @return Success
     */
    getEvents(eventId?: number | undefined, correlationId?: string | undefined, messageId?: string | undefined, companyId?: number | undefined, integrationEventId?: number | undefined, entityId?: string | undefined, startDate?: string | undefined, endDate?: string | undefined, top?: number | undefined): Observable<EventDto[]> {
        let url_ = this.baseUrl + "/api/Events?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (correlationId === null)
            throw new Error("The parameter 'correlationId' cannot be null.");
        else if (correlationId !== undefined)
            url_ += "correlationId=" + encodeURIComponent("" + correlationId) + "&";
        if (messageId === null)
            throw new Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (integrationEventId === null)
            throw new Error("The parameter 'integrationEventId' cannot be null.");
        else if (integrationEventId !== undefined)
            url_ += "integrationEventId=" + encodeURIComponent("" + integrationEventId) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto[]>;
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<EventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEventById(eventId: number): Observable<EventDto> {
        let url_ = this.baseUrl + "/api/Events/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventDto>;
        }));
    }

    protected processGetEventById(response: HttpResponseBase): Observable<EventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Accepted
     */
    ingestEvent(body?: EventIngestRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Events/ingest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIngestEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIngestEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIngestEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param scope (optional) 
     * @return Success
     */
    getEntityMetadata(entityType: string, entityId: string, scope?: string | undefined): Observable<EntityMetadataResponseDto> {
        let url_ = this.baseUrl + "/api/Metadata/{entityType}/{entityId}?";
        if (entityType === undefined || entityType === null)
            throw new Error("The parameter 'entityType' must be defined.");
        url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (scope === null)
            throw new Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityMetadataResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityMetadataResponseDto>;
        }));
    }

    protected processGetEntityMetadata(response: HttpResponseBase): Observable<EntityMetadataResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityMetadataResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param processId (optional) 
     * @param processTemplateId (optional) 
     * @param eventId (optional) 
     * @param externalEntityId (optional) 
     * @return Success
     */
    getProcessInstances(processId?: number | undefined, processTemplateId?: number | undefined, eventId?: number | undefined, externalEntityId?: string | undefined): Observable<ProcessInstanceSummaryDto[]> {
        let url_ = this.baseUrl + "/api/Processes?";
        if (processId === null)
            throw new Error("The parameter 'processId' cannot be null.");
        else if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        if (processTemplateId === null)
            throw new Error("The parameter 'processTemplateId' cannot be null.");
        else if (processTemplateId !== undefined)
            url_ += "processTemplateId=" + encodeURIComponent("" + processTemplateId) + "&";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (externalEntityId === null)
            throw new Error("The parameter 'externalEntityId' cannot be null.");
        else if (externalEntityId !== undefined)
            url_ += "externalEntityId=" + encodeURIComponent("" + externalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessInstances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessInstances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessInstanceSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessInstanceSummaryDto[]>;
        }));
    }

    protected processGetProcessInstances(response: HttpResponseBase): Observable<ProcessInstanceSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessInstanceSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @return Success
     */
    getProcessTemplates(isActive?: boolean | undefined): Observable<ProcessTemplateDto[]> {
        let url_ = this.baseUrl + "/api/ProcessTemplates?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessTemplateDto[]>;
        }));
    }

    protected processGetProcessTemplates(response: HttpResponseBase): Observable<ProcessTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessTemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProcessTemplateById(processTemplateId: number): Observable<ProcessDefinitionDto> {
        let url_ = this.baseUrl + "/api/ProcessTemplates/{processTemplateId}";
        if (processTemplateId === undefined || processTemplateId === null)
            throw new Error("The parameter 'processTemplateId' must be defined.");
        url_ = url_.replace("{processTemplateId}", encodeURIComponent("" + processTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessTemplateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessTemplateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessDefinitionDto>;
        }));
    }

    protected processGetProcessTemplateById(response: HttpResponseBase): Observable<ProcessDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class EntityMetadataDto implements IEntityMetadataDto {
    scope?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
    valueType?: string | undefined;

    constructor(data?: IEntityMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): EntityMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["key"] = this.key;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}

export interface IEntityMetadataDto {
    scope?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
    valueType?: string | undefined;
}

export class EntityMetadataResponseDto implements IEntityMetadataResponseDto {
    entityType?: string | undefined;
    entityId?: string | undefined;
    metadata?: EntityMetadataDto[] | undefined;

    constructor(data?: IEntityMetadataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["metadata"])) {
                this.metadata = [] as any;
                for (let item of _data["metadata"])
                    this.metadata!.push(EntityMetadataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntityMetadataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetadataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        if (Array.isArray(this.metadata)) {
            data["metadata"] = [];
            for (let item of this.metadata)
                data["metadata"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IEntityMetadataResponseDto {
    entityType?: string | undefined;
    entityId?: string | undefined;
    metadata?: EntityMetadataDto[] | undefined;
}

export class EstimatedTimeDto implements IEstimatedTimeDto {
    minMinutes?: number;
    maxMinutes?: number;

    constructor(data?: IEstimatedTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minMinutes = _data["minMinutes"];
            this.maxMinutes = _data["maxMinutes"];
        }
    }

    static fromJS(data: any): EstimatedTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EstimatedTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minMinutes"] = this.minMinutes;
        data["maxMinutes"] = this.maxMinutes;
        return data;
    }
}

export interface IEstimatedTimeDto {
    minMinutes?: number;
    maxMinutes?: number;
}

export class EventDto implements IEventDto {
    eventId?: number;
    eventStartDate?: string | undefined;
    eventEndDate?: string | undefined;
    eventEnqueuedAt?: string;
    correlationId?: string | undefined;
    integrationEventId?: number;
    eventLabel?: string | undefined;
    eventProperties?: string | undefined;
    eventBody?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: string;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;
    isDeleted?: boolean;
    entityId?: string | undefined;
    companyId?: number | undefined;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventStartDate = _data["eventStartDate"];
            this.eventEndDate = _data["eventEndDate"];
            this.eventEnqueuedAt = _data["eventEnqueuedAt"];
            this.correlationId = _data["correlationId"];
            this.integrationEventId = _data["integrationEventId"];
            this.eventLabel = _data["eventLabel"];
            this.eventProperties = _data["eventProperties"];
            this.eventBody = _data["eventBody"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"];
            this.isDeleted = _data["isDeleted"];
            this.entityId = _data["entityId"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): EventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventStartDate"] = this.eventStartDate;
        data["eventEndDate"] = this.eventEndDate;
        data["eventEnqueuedAt"] = this.eventEnqueuedAt;
        data["correlationId"] = this.correlationId;
        data["integrationEventId"] = this.integrationEventId;
        data["eventLabel"] = this.eventLabel;
        data["eventProperties"] = this.eventProperties;
        data["eventBody"] = this.eventBody;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn;
        data["isDeleted"] = this.isDeleted;
        data["entityId"] = this.entityId;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IEventDto {
    eventId?: number;
    eventStartDate?: string | undefined;
    eventEndDate?: string | undefined;
    eventEnqueuedAt?: string;
    correlationId?: string | undefined;
    integrationEventId?: number;
    eventLabel?: string | undefined;
    eventProperties?: string | undefined;
    eventBody?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: string;
    updatedBy?: string | undefined;
    updatedOn?: string | undefined;
    isDeleted?: boolean;
    entityId?: string | undefined;
    companyId?: number | undefined;
}

export class EventIngestRequestDto implements IEventIngestRequestDto {
    eventName?: string | undefined;
    sourceSystem?: SourceSystem;
    payload?: any;
    messageId?: string | undefined;
    correlationId?: string | undefined;
    entityId?: string | undefined;
    occurredAt?: string | undefined;
    metadata?: any | undefined;

    constructor(data?: IEventIngestRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventName = _data["eventName"];
            this.sourceSystem = _data["sourceSystem"];
            this.payload = _data["payload"];
            this.messageId = _data["messageId"];
            this.correlationId = _data["correlationId"];
            this.entityId = _data["entityId"];
            this.occurredAt = _data["occurredAt"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): EventIngestRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventIngestRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventName"] = this.eventName;
        data["sourceSystem"] = this.sourceSystem;
        data["payload"] = this.payload;
        data["messageId"] = this.messageId;
        data["correlationId"] = this.correlationId;
        data["entityId"] = this.entityId;
        data["occurredAt"] = this.occurredAt;
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface IEventIngestRequestDto {
    eventName?: string | undefined;
    sourceSystem?: SourceSystem;
    payload?: any;
    messageId?: string | undefined;
    correlationId?: string | undefined;
    entityId?: string | undefined;
    occurredAt?: string | undefined;
    metadata?: any | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProcessDefinitionDto implements IProcessDefinitionDto {
    processTemplate?: ProcessTemplateDto | undefined;
    steps?: ProcessStepDto[] | undefined;

    constructor(data?: IProcessDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processTemplate = _data["processTemplate"] ? ProcessTemplateDto.fromJS(_data["processTemplate"]) : <any>undefined;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(ProcessStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processTemplate"] = this.processTemplate ? this.processTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProcessDefinitionDto {
    processTemplate?: ProcessTemplateDto | undefined;
    steps?: ProcessStepDto[] | undefined;
}

export class ProcessInstanceSummaryDto implements IProcessInstanceSummaryDto {
    processId?: number;
    status?: string | undefined;
    processTemplateId?: number | undefined;
    externalEntityId?: string | undefined;
    startedOn?: string | undefined;

    constructor(data?: IProcessInstanceSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processId = _data["processId"];
            this.status = _data["status"];
            this.processTemplateId = _data["processTemplateId"];
            this.externalEntityId = _data["externalEntityId"];
            this.startedOn = _data["startedOn"];
        }
    }

    static fromJS(data: any): ProcessInstanceSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessInstanceSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["status"] = this.status;
        data["processTemplateId"] = this.processTemplateId;
        data["externalEntityId"] = this.externalEntityId;
        data["startedOn"] = this.startedOn;
        return data;
    }
}

export interface IProcessInstanceSummaryDto {
    processId?: number;
    status?: string | undefined;
    processTemplateId?: number | undefined;
    externalEntityId?: string | undefined;
    startedOn?: string | undefined;
}

export class ProcessStepDto implements IProcessStepDto {
    stepId?: number;
    name?: string | undefined;
    stepType?: string | undefined;
    sequence?: number | undefined;
    isOptional?: boolean | undefined;
    estimatedTime?: EstimatedTimeDto | undefined;
    parentStepId?: number | undefined;
    isAutoComplete?: boolean | undefined;
    systemOfRecord?: string | undefined;
    integrationEventId?: number | undefined;
    failureIntegrationEventId?: number | undefined;
    integrationEventName?: string | undefined;
    failureIntegrationEventName?: string | undefined;
    dependencies?: number[] | undefined;
    dependants?: number[] | undefined;

    constructor(data?: IProcessStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepId = _data["stepId"];
            this.name = _data["name"];
            this.stepType = _data["stepType"];
            this.sequence = _data["sequence"];
            this.isOptional = _data["isOptional"];
            this.estimatedTime = _data["estimatedTime"] ? EstimatedTimeDto.fromJS(_data["estimatedTime"]) : <any>undefined;
            this.parentStepId = _data["parentStepId"];
            this.isAutoComplete = _data["isAutoComplete"];
            this.systemOfRecord = _data["systemOfRecord"];
            this.integrationEventId = _data["integrationEventId"];
            this.failureIntegrationEventId = _data["failureIntegrationEventId"];
            this.integrationEventName = _data["integrationEventName"];
            this.failureIntegrationEventName = _data["failureIntegrationEventName"];
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [] as any;
                for (let item of _data["dependencies"])
                    this.dependencies!.push(item);
            }
            if (Array.isArray(_data["dependants"])) {
                this.dependants = [] as any;
                for (let item of _data["dependants"])
                    this.dependants!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        data["name"] = this.name;
        data["stepType"] = this.stepType;
        data["sequence"] = this.sequence;
        data["isOptional"] = this.isOptional;
        data["estimatedTime"] = this.estimatedTime ? this.estimatedTime.toJSON() : <any>undefined;
        data["parentStepId"] = this.parentStepId;
        data["isAutoComplete"] = this.isAutoComplete;
        data["systemOfRecord"] = this.systemOfRecord;
        data["integrationEventId"] = this.integrationEventId;
        data["failureIntegrationEventId"] = this.failureIntegrationEventId;
        data["integrationEventName"] = this.integrationEventName;
        data["failureIntegrationEventName"] = this.failureIntegrationEventName;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item);
        }
        if (Array.isArray(this.dependants)) {
            data["dependants"] = [];
            for (let item of this.dependants)
                data["dependants"].push(item);
        }
        return data;
    }
}

export interface IProcessStepDto {
    stepId?: number;
    name?: string | undefined;
    stepType?: string | undefined;
    sequence?: number | undefined;
    isOptional?: boolean | undefined;
    estimatedTime?: EstimatedTimeDto | undefined;
    parentStepId?: number | undefined;
    isAutoComplete?: boolean | undefined;
    systemOfRecord?: string | undefined;
    integrationEventId?: number | undefined;
    failureIntegrationEventId?: number | undefined;
    integrationEventName?: string | undefined;
    failureIntegrationEventName?: string | undefined;
    dependencies?: number[] | undefined;
    dependants?: number[] | undefined;
}

export class ProcessTemplateDto implements IProcessTemplateDto {
    processTemplateId?: number;
    name?: string | undefined;
    description?: string | undefined;
    version?: number;
    isActive?: boolean;

    constructor(data?: IProcessTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processTemplateId = _data["processTemplateId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.version = _data["version"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProcessTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processTemplateId"] = this.processTemplateId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["version"] = this.version;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IProcessTemplateDto {
    processTemplateId?: number;
    name?: string | undefined;
    description?: string | undefined;
    version?: number;
    isActive?: boolean;
}

export enum SourceSystem {
    Workday = "Workday",
    Manual = "Manual",
    System = "System",
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}